import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { Router } from "@angular/router";

@Component({
    selector: "app-category-box",
    templateUrl: "./category-box.component.html",
    styleUrls: ["./category-box.component.scss"],
    standalone: false
})
export class CategoryBoxComponent implements OnInit {
  @Input() public categoryContent;
  @Input() public planCategory;
  @Input() public categorySections;
  @Output() public deletedItem: EventEmitter<string> =
    new EventEmitter<string>();

  public collapseStatus = [];

  constructor(private router: Router) {}

  ngOnInit() {}

  goto() {
    this.router.navigate(["/home"]);
  }

  showAnswerDelete(choice) {
    if (choice === "Yes") {
      this.deletedItem.emit(choice);
    }
  }
}
